import { render, staticRenderFns } from "./searchDetail.vue?vue&type=template&id=33a3e675&scoped=true"
import script from "./searchDetail.vue?vue&type=script&lang=js"
export * from "./searchDetail.vue?vue&type=script&lang=js"
import style0 from "./searchDetail.vue?vue&type=style&index=0&id=33a3e675&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a3e675",
  null
  
)

export default component.exports